var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgStepTypeInput = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 22,
  height: 22,
  viewBox: "0 0 22 22",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 20C15.9706 20 20 15.9706 20 11C20 6.02944 15.9706 2 11 2C6.02944 2 2 6.02944 2 11C2 15.9706 6.02944 20 11 20ZM11 22C17.0751 22 22 17.0751 22 11C22 4.92487 17.0751 0 11 0C4.92487 0 0 4.92487 0 11C0 17.0751 4.92487 22 11 22Z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M11 7C11.5523 7 12 7.44772 12 8L12 14C12 14.5523 11.5523 15 11 15C10.4477 15 10 14.5523 10 14L10 8C10 7.44772 10.4477 7 11 7Z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.9749 11.0607C15.3654 11.4512 15.3654 12.0844 14.9749 12.4749L11 16.4498L7.02512 12.4749C6.6346 12.0844 6.6346 11.4512 7.02512 11.0607C7.41564 10.6702 8.04881 10.6702 8.43933 11.0607L11 13.6214L13.5607 11.0607C13.9512 10.6702 14.5844 10.6702 14.9749 11.0607Z"
})));
export default SvgStepTypeInput;